export enum NotificationActionEnum {
    Email,
    FogBugz
}



// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/models/NotificationActionEnum.ts